import BASIC from '@/config/js/basicConfig.js'
import CONSTANT from '@/config/js/constantConfig.js'
import METHOD from '@/config/js/methodConfig.js'

export default {
  ...BASIC,
  ...CONSTANT,
  ...METHOD
}
